const state = {
  creditOfferedBudgetRelations: [],
};

const getters = {
  getCreditOfferedBudgetRelations: (state) => state.creditOfferedBudgetRelations,
};

const actions = {
  addBudgetManagementToCreditOffered({ commit }, payload) {
    commit('setCreditOfferedBudgetRelation', payload);
  },

  removeBudgetManagementFromCreditOffered({ commit }, credit_offered_id) {
    commit('removeCreditOfferedBudgetRelation', credit_offered_id);
  },

  clearAllBudgetManagementRelations({ commit }) {
    commit('clearCreditOfferedBudgetRelations');
  },
};

const mutations = {
  setCreditOfferedBudgetRelation($state, { credit_offered_id, budget_management_id }) {
    const stateCopy = $state;
    const existingIndex = stateCopy.creditOfferedBudgetRelations.findIndex(
      (item) => item.credit_offered_id === credit_offered_id,
    );
    const params = {
      credit_offered_id,
      budget_management_id,
    };

    if (existingIndex !== -1) {
      return stateCopy.creditOfferedBudgetRelations[existingIndex] = params;
    }

    stateCopy.creditOfferedBudgetRelations.push(params);
  },

  removeCreditOfferedBudgetRelation($state, credit_offered_id) {
    const stateCopy = $state;
    stateCopy.creditOfferedBudgetRelations = stateCopy.creditOfferedBudgetRelations.filter(
      (item) => item.credit_offered_id !== credit_offered_id,
    );
  },

  clearCreditOfferedBudgetRelations($state) {
    const stateCopy = $state;
    stateCopy.creditOfferedBudgetRelations = [];
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
